// ** MUI Imports
import Box from '@mui/material/Box';

// ** Type Import
import type { Settings } from '@erikdakoda/site-template-ui/context/settingsContext';

// ** Components
import UserDropdown from './UserDropdown';

interface Props {
  settings: Settings;
  saveSettings: (values: Settings) => void;
}
const AppBarContent = (props: Props) => {
  // ** Props
  const { settings, saveSettings } = props;

  return (
    <Box sx={{ display: 'flex', alignItems: 'center' }}>
      <UserDropdown settings={settings} saveSettings={saveSettings} />
    </Box>
  );
};

export default AppBarContent;
